import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    data: null,
    dataList: null,
    message: null,
    error: null,
    createStatus: null,
    updateStatus: null
}

const templateSlice = createSlice({
    name: 'template',
    initialState,
    reducers: {
        getTemplateStart: (state) => {
            state.isLoading = true;
            state.data = null;
            state.message = null;
        },
        getTemplateSuccess: (state, action) => {
            state.data = action?.payload?.printTemplates;
            state.dataList = action?.payload?.printTemplates;
            state.message = action?.payload?.message;
            state.isLoading = false
        },
        getTemplateFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false
        },
        createTemplateStart: (state, action) => {
            state.isLoading = true;
            state.message = null;
            state.data = null
            state.createStatus = null;
        },
        createTemplateSuccess: (state, action) => {
            state.message = action?.payload?.message;
            state.data = action?.payload?.savedPrintTemplate;
            state.isLoading = false;
            state.createStatus = action?.payload?.success;
        },
        createTemplateFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload || action?.payload?.message;
            state.createStatus = false;
        },
        updateTemplateStart: (state, action) => {
            state.isLoading = true;
            state.message = null;
            state.data = null
            state.updateStatus = null;
        },
        updateTemplateSuccess: (state, action) => {
            state.message = action?.payload?.message || action?.payload;
            state.data = action?.payload?.savedPrintTemplate;
            state.isLoading = false;
            state.updateStatus = action?.payload?.success;
        },
        updateTemplateFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message
            state.updateStatus = action?.payload?.success;
        },
        resetState: (state) => {
            state.isLoading = false;
            state.data = null;
            state.message = null;
            state.error = null;
            state.createStatus = null;
            state.updateStatus = null;
        },
        clearMessage: (state) => {
            // state.isLoading = false;
            state.message = null;
            state.error = null;
            state.createStatus = null;
            state.updateStatus = null;
        }
    }
})

export const {
    getTemplateStart,
    getTemplateSuccess,
    getTemplateFailure,
    createTemplateStart,
    createTemplateSuccess,
    createTemplateFailure,
    updateTemplateStart,
    updateTemplateSuccess,
    updateTemplateFailure,
    resetState,
    clearMessage
} = templateSlice?.actions

export default templateSlice?.reducer;